export default "__VITE_ASSET__BWkP9zwJ__"